import React, { useState } from 'react';
import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Collapse,
  Text,
  Flex,
  
} from '@chakra-ui/react';

function formatDuration(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return `${h} hrs ${m} mins ${s} secs`;
}

function getDateFromISO(isoString) {
  return new Date(isoString).toISOString().split('T')[0];
}

function calculateDuration(on, off) {
  const start = new Date(on);
  const end = new Date(off);
  const seconds = Math.floor((end - start) / 1000);
  return seconds >= 0 ? seconds : 0;
}

function AllLogsTable({ rawLogs, handleLogs }) {
  const [showLogs, setShowLogs] = useState(false);

  // Group logs by date
  const groupedByDate = rawLogs.reduce((acc, log) => {
    const date = getDateFromISO(log.on);
    if (!acc[date]) acc[date] = [];
    acc[date].push(log);
    return acc;
  }, {});

  return (
    <Box p={4} bg="white.800" rounded="md" >
      <Flex mb={10} justify="center" mt={4} gap={4}>
        <Button colorScheme="blue" onClick={() => setShowLogs(!showLogs)}>
          {showLogs ? "Hide Logs" : "See All Logs >>"}
        </Button>
        <Button colorScheme="green" onClick={handleLogs}>
          Copy Logs
        </Button>
      </Flex>


      <Collapse in={showLogs} animateOpacity>
        {Object.keys(groupedByDate).map((date, idx) => {
          const logs = groupedByDate[date];
          const totalDuration = logs.reduce(
            (acc, log) => acc + calculateDuration(log.on, log.off),
            0
          );

          return (
            <Box key={idx} w="80%" m="auto" mt={5} p={4} border="1px solid #B2BEB5	" shadow="md" rounded="md">
              {idx === 0 && (
                <Text fontSize="sm" color="gray.600" mt={2}>
                  <strong>Note:</strong> All logs are grouped by the same shift.
                  For example, if your shift starts on Sept 2 at 7:00 PM CST and ends on Sept 3 at 4:00 AM CST,
                  the entire shift will still be counted under <strong>Sept 2 (CST)</strong>.
                </Text>
              )}

              <Text textAlign="center" fontSize="lg" fontWeight="bold" mb={2}>
                {date}
              </Text>
              <Table rounded="md" variant="simple" size="md" bg="gray.500">
                <Thead>
                  <Tr>
                    <Th color="white">#</Th>
                    <Th color="white">Date</Th>
                    <Th color="white">On Time</Th>
                    <Th color="white">Off Time</Th>
                    <Th color="white">Duration</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {logs.map((log, i) => {
                    const on = new Date(log.on);
                    const off = new Date(log.off);
                    const duration = calculateDuration(log.on, log.off);
                    return (
                      <Tr key={i}>
                        <Td color="white">{i + 1}</Td>
                        <Td color="white">{getDateFromISO(log.on)}</Td>
                        <Td color="white">
                          {on.toLocaleTimeString('en-US', { hour12: false })}
                        </Td>
                        <Td color="white">
                          {off.toLocaleTimeString('en-US', { hour12: false })}
                        </Td>
                        <Td color="white">{formatDuration(duration)}</Td>
                      </Tr>
                    );
                  })}
                  <Tr>
                    <Td colSpan={4} color="white" fontWeight="bold" textAlign="right">
                      Total Duration:
                    </Td>
                    <Td color="white" fontWeight="bold">
                      {formatDuration(totalDuration)}
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>
          );
        })}
      </Collapse>
    </Box>
  );
}

export default AllLogsTable;
